export const TOGGLE_STRUCTURE_FILTER_MENU = 'ibw/SearchFilters/TOGGLE_STRUCTURE_FILTER_MENU';
